import React from 'react';
import PageRenderer from '../../components/common/PageRenderer';

function DefaultContent() {
  return (
    <>
      <section className="relative overflow-hidden bg-[#0B5D1E]" style={{ backgroundImage: 'linear-gradient(135deg, #0B5D1E 0%, #094A18 100%)' }}>
        <div className="relative" style={{ paddingTop: 80, paddingBottom: 80, zIndex: 1 }}>
          <div className="max-w-5xl mx-auto px-4 text-center">
            <h1 style={{ fontSize: 'clamp(2rem, 5vw, 3rem)', fontWeight: 700, color: '#fff', marginBottom: 16, fontFamily: "'Playfair Display',serif" }}>
              About Us
            </h1>
            <p className="text-white/70 text-lg max-w-2xl mx-auto">
              Learn about the Nigerian Institution of Surveyors, FCT Branch
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-5xl mx-auto px-4">
          <div className="prose prose-gray max-w-none">
            <h2 className="text-2xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Playfair Display',serif" }}>Who We Are</h2>
            <p className="text-gray-600 leading-relaxed mb-6">
              The Nigerian Institution of Surveyors (NIS), FCT Branch, is the professional body representing surveyors in the Federal Capital Territory. We are dedicated to promoting excellence, professional development, and ethical practice in the surveying profession.
            </p>
            <p className="text-gray-600 leading-relaxed mb-6">
              Our members include licensed surveyors, graduate surveyors, and survey technicians who are committed to advancing the science and art of surveying in all its branches.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 bg-[#F8FAFB]">
        <div className="max-w-5xl mx-auto px-4 text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-10" style={{ fontFamily: "'Playfair Display',serif" }}>What We Do</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              { icon: '\uD83C\uDFAF', title: 'Professional Development', desc: 'Organizing workshops, seminars, and training programs for members.' },
              { icon: '\uD83E\uDD1D', title: 'Advocacy', desc: 'Representing the interests of surveyors at government and industry levels.' },
              { icon: '\uD83C\uDFC6', title: 'Standards & Ethics', desc: 'Upholding the highest standards of practice and professional conduct.' },
            ].map((item) => (
              <div key={item.title} className="bg-white rounded-xl p-6 border border-gray-100 shadow-sm">
                <div className="text-3xl mb-3">{item.icon}</div>
                <h3 className="text-lg font-bold text-[#0B5D1E] mb-2">{item.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default function About() {
  return <PageRenderer pageKey="about" fallback={<DefaultContent />} />;
}
